import React from "react";
import { motionSafe as motion } from "@/lib/motionSafe";
import { Linkedin, ArrowUpRight, Rss } from "lucide-react";
import { useI18n } from "../../i18n";

const NEWSLETTER_URL =
  "https://www.linkedin.com/build-relation/newsletter-follow?entityUrn=7379873272445894656";

export const Newsletter = () => {
  const { t } = useI18n();
  const n = t.newsletter;

  return (
    <section id="newsletter" data-testid="newsletter-section" className="relative py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <motion.div
          initial={{ opacity: 1, y: 14 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
          className="relative glass rounded-sm overflow-hidden"
        >
          {/* Background accents */}
          <div className="absolute inset-0 grid-lines opacity-40 pointer-events-none" />
          <div className="absolute -top-32 -right-32 w-96 h-96 rounded-full bg-[#0052FF]/25 blur-3xl pointer-events-none" />
          <div className="absolute -bottom-24 -left-24 w-72 h-72 rounded-full bg-[#00E1FF]/10 blur-3xl pointer-events-none" />

          <div className="relative p-8 md:p-14 grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-center">
            <div className="lg:col-span-8">
              <div className="inline-flex items-center gap-2 font-mono-tech text-xs tracking-[0.25em] uppercase text-[#3B82F6] mb-6">
                <Rss size={14} strokeWidth={2} />
                {n.overline}
              </div>
              <h2 className="font-display font-extrabold tracking-tight text-3xl md:text-4xl lg:text-5xl leading-[1.05] text-white">
                {n.title}
              </h2>
              <p className="mt-5 text-base md:text-lg text-gray-400 leading-relaxed max-w-2xl">
                {n.sub}
              </p>
            </div>

            <div className="lg:col-span-4 flex flex-col items-start lg:items-end gap-4">
              <div className="font-mono-tech text-[10px] tracking-[0.2em] uppercase text-gray-400 border border-white/15 rounded-full px-3 py-1">
                {n.badge}
              </div>
              <a
                href={NEWSLETTER_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="newsletter-cta"
                className="trace-btn group inline-flex items-center gap-3 bg-[#0052FF] hover:bg-[#2563EB] text-white font-medium px-6 py-4 rounded-sm transition-colors duration-200 w-full lg:w-auto justify-center lg:justify-start"
              >
                <Linkedin size={18} />
                <span>{n.cta}</span>
                <ArrowUpRight size={16} className="group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform duration-200" />
              </a>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
